exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "vg-preroll{position:absolute;top:0;background:#000}vg-preroll,vg-preroll video{width:100%;height:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/preroll/preroll.scss
 ** module id = 246
 ** module chunks = 0
 **/